/* eslint-disable angular/module-name,angular/file-name */
angular.module('zc.master.zcliteAgencyInvoices', [
  'zc.master'
]);



// WEBPACK FOOTER //
// ./src/master_admin_modules/master.zclite_agency_invoices/index.js